module.exports = __webpack_public_path__ + "img/warning-icon.682ede4c.svg";